import React, { Component } from "react";
import { Button, Col, Icon, Input, Row, Switch } from "antd";
import { devMode, urlPath } from "./Settings";
import { checkPermission, getAuthHeader } from "../utils/security";

const { TextArea } = Input;
const ButtonGroup = Button.Group;

/* eslint jsx-a11y/href-no-hash: 0 */
class AnnotationWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      annotationDate: "date",
      annotationText: "",
      annotationUser: "user",
      annotationWidgets: [],
      currentUser: null,
      preview: null,
      replies: [],
      replyFormVisible: false,
      replyInfo: "reply info",
      replyText: "reply text",
      replyValue: null,
      showAllVersions: false
    };
  }
  handleCancel = () => {
    this.setState({
      visible: false
    });
  };
  handleOk = () => {
    this.setState({
      visible: false
    });
  };
  handleChange = () => {
    console.log("selecting color");
  };
  toDateTime = secs => {
    let date = new Date(1970, 0, 1); // Epoch
    date.setSeconds(secs);
    console.log(date);
    date = date.toLocaleString();
    return date;
  };
  getUser = id => {
    fetch(urlPath + "/api/getuser?id=" + id, {
      credentials: "include",
      headers: getAuthHeader()
    })
      .then(response => response.json())
      .then(data => {
        if (data && data.user.name) {
          console.log("getUser loaded: " + data.user.id + ":" + data.user.name);
          const userIds = document.getElementsByClassName(
            "annotation-reply-info"
          );
          for (let i = 0; i < userIds.length; i++) {
            console(
              "typeof",
              typeof userIds[i].getAttribute("data-userid"),
              typeof id
            );
            // eslint-disable-next-line
            if (userIds[i].getAttribute("data-userid") == id)
              // TODO check if === could be used
              userIds[i].innerHTML = data.user.name;
          }
        }
      })
      .catch(e => console.error("Cannot load getUser", e));
  };
  handleReview = e => {
    console.log("Review", e.target);
    const element = e.target;
    const annotationWidget = element.closest(".annotation-widget");
    const admaterial = annotationWidget.getAttribute("data-admaterial");
    const positionX = annotationWidget.getAttribute("data-positionX");
    const positionY = annotationWidget.getAttribute("data-positionY");
    const color = annotationWidget.getAttribute("data-color");
    const text = annotationWidget.getAttribute("data-annotationText");
    const reviewed = true;
    const id = annotationWidget.getAttribute("data-id");
    annotationWidget.setAttribute("data-reviewed", true);
    let url = urlPath + "/api/annotationsave?admaterial=" + admaterial
      + "&x=" + positionX + "&y=" + positionY + "&w=10&h=10&color=" + color + "&text=" + encodeURIComponent(text) + "&reviewed=" + reviewed;
    if (id) url += "&id=" + id;
    if (id) {
      fetch(url, { method: "POST", credentials: "include", headers: getAuthHeader() })
        .then(response => {
          console.log("Submitted note", response.text());
          element.setAttribute("disabled", "disabled");
          document
            .getElementById("reviewLabel." + id)
            .classList.remove("d-none");
        })
        .catch(e => console.error("Cannot submit note", e));
    }
    e.stopPropagation();
  };
  addWidget = (admaterial, annotations) => {
    const { annotationWidgets, showAllVersions } = this.state;
    let replies = null;
    if (annotations)
      for (let i = annotations.length - 1; i >= 0; i--) {
        if (
          (!this.props.assetView &&
            admaterial &&
            annotations[i].parent.includes(admaterial)) ||
          (this.props.assetView &&
            annotations[i].parent.includes(this.props.assetVisualId)) ||
          showAllVersions
        ) {
          replies = [];
          for (let z = 0; z < annotations[i].comments.length; z++) {
            const replyDate = this.toDateTime(
              annotations[i].comments[z].creationDate.seconds
            );
            const userId = annotations[i].comments[z].userId;
            const userName = this.getUser(userId);
            if (
              annotations[i].comments[z] &&
              this.state.currentUserId === annotations[i].comments[z].userId
            ) {
              replies.push(
                <div className="annotation-reply-same-user">
                  <div key className="annotation-reply">
                    <div className="annotation-reply-info" data-userid={userId}>
                      {userName ? userName : userId}
                    </div>
                    <span className="annotation-reply-date">{replyDate}</span>
                    <div className="annotation-reply-text">
                      {annotations[i].comments[z].text}
                    </div>
                  </div>
                </div>
              );
            } else {
              replies.push(
                <div key className="annotation-reply">
                  <div className="annotation-reply-info" data-userid={userId}>
                    {userName ? userName : userId}
                  </div>
                  <span className="annotation-reply-date">{replyDate}</span>
                  <div className="annotation-reply-text">
                    {annotations[i].comments[z].text}
                  </div>
                </div>
              );
            }
          }
          if (!devMode) {
            const noteText = annotations[i].text;
            const notePreview = this.props.bigpreviewArray
              ? this.props.bigpreviewArray[annotations[i].page]
              : this.state.preview;
            annotationWidgets.push(
              <section
                data-reviewed={annotations[i].marked}
                className="annotation-widget"
                id={"widget." + annotations[i].id}
                data-id={annotations[i].id}
                data-annotationText={annotations[i].text}
                data-annotationId={annotations[i].id}
                data-admaterial={this.props.admaterial}
                data-type="STICKER"
                data-color={annotations[i].color}
                data-positionX={annotations[i].signals[0].x}
                data-positionY={annotations[i].signals[0].y}
                onClick={() => {
                  document
                    .getElementById("annotationPost." + annotations[i].id)
                    .click();
                  document
                    .getElementById("annotationCanvas")
                    .classList.add("visible");
                }}
              >
                <div className="annotation-widget-header">
                  <div className="annotation-widget-data-page">
                    <span data-translationkey="page">
                      {this.props.translations.page} {annotations[i].page + 1}{" "}
                    </span>
                  </div>
                  <div
                    className="annotation-widget-preview"
                    style={{ backgroundImage: "url(" + notePreview + ")" }}
                  >
                    <img src={notePreview} alt="preview" />
                  </div>
                  <div className="annotation-widget-information">
                    <div className="annotation-widget-type">
                      <img
                        src={this.state.typeThumb}
                        style={{ display: "none" }}
                        alt="type"
                      />
                    </div>
                    <div className="annotation-widget-data">
                      <div className="annotation-widget-data-user">
                        {annotations[i].creator.name}
                      </div>
                      <div className="annotation-widget-data-date">
                        {annotations[i].time}
                      </div>
                      {annotations[i].marked ? (
                        <div
                          id={"reviewLabel." + annotations[i].id}
                          className="annotation-widget-data-reviewed"
                        >
                          <Icon
                            style={{ color: "#2ecc71", marginRight: "3px" }}
                            type="check-circle"
                          />
                          <span data-translationkey="reviewed">
                            {this.props.translations
                              ? this.props.translations.reviewed
                              : "Reviewed"}
                          </span>
                        </div>
                      ) : (
                          <div
                            id={"reviewLabel." + annotations[i].id}
                            className="d-none annotation-widget-data-reviewed"
                          >
                            <Icon
                              style={{ color: "#2ecc71", marginRight: "3px" }}
                              type="check-circle"
                            />
                            <span data-translationkey="reviewed">
                              {this.props.translations
                                ? this.props.translations.reviewed
                                : "Reviewed"}
                            </span>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
                <div
                  className="annotation-note"
                  id={"annotationWidgetNote." + annotations[i].id}
                >
                  {noteText.replace(/\\n/g, "\n").replace(/\%20/g, " ").replace(/\%0A/g, " ")}
                </div>
                {this.props.editableView && (
                  <a
                    data-translationkey="previouseComments"
                    className="annotation-previous-comments"
                    id="annotation-previous-comments"
                    href="#"
                  >
                    {this.props.translations
                      ? this.props.translations.previousComments
                      : "Previous comments..."}
                  </a>
                )}
                <div
                  className="annotation-reply-container"
                  id={"replyBox." + annotations[i].id}
                >
                  <div>{replies}</div>
                </div>
                <footer id="annotation-widget-buttons">
                  {this.props.editableView && (
                    <div className="annotation-buttons">
                      <ButtonGroup size="small">
                        <Button
                          data-translationkey="review"
                          disabled={annotations[i].marked ? "disabled" : ""}
                          type="primary"
                          className="ann-btn-review"
                          onClick={e => this.handleReview(e)}
                        >
                          {this.props.translations.review}
                        </Button>
                        <Button
                          data-translationkey="open"
                          type="primary"
                          className={
                            "d-none ann-btn-open " +
                            (this.state.replyFormVisible ? "d-none" : "")
                          }
                          onClick={() => {
                            document
                              .getElementById(
                                "annotationPost." + annotations[i].id
                              )
                              .click();
                            document
                              .getElementById("annotationCanvas")
                              .classList.add("visible");
                          }}
                        >
                          {this.props.translations.open}
                        </Button>
                        {typeof annotations[i].id === "string" &&
                          annotations[i].id.includes("-") ? (
                            <Button
                              data-translationkey="chat"
                              disabled
                              type="primary"
                              className={
                                "ann-btn-reply " +
                                (this.state.replyFormVisible ? "d-none" : "")
                              }
                              onClick={e => {
                                document.getElementById(
                                  "annotationInput." + annotations[i].id
                                ).style.display = "block";
                                setTimeout(function () {
                                  document
                                    .getElementById(
                                      "annotationTextarea." + annotations[i].id
                                    )
                                    .focus();
                                }, 0);
                                e.stopPropagation();
                              }}
                            >
                              {this.props.translations.chat}
                            </Button>
                          ) : (
                            <Button
                              data-translationkey="chat"
                              type="primary"
                              className={
                                "ann-btn-reply " +
                                (this.state.replyFormVisible ? "d-none" : "")
                              }
                              onClick={e => {
                                document.getElementById(
                                  "annotationInput." + annotations[i].id
                                ).style.display = "block";
                                setTimeout(function () {
                                  document
                                    .getElementById(
                                      "annotationTextarea." + annotations[i].id
                                    )
                                    .focus();
                                }, 0);
                                e.stopPropagation();
                              }}
                            >
                              {this.props.translations.chat}
                            </Button>
                          )}
                      </ButtonGroup>
                    </div>
                  )}
                  <div
                    className="annotation-form"
                    id={"annotationInput." + annotations[i].id}
                  >
                    <TextArea
                      id={"annotationTextarea." + annotations[i].id}
                      className="annotation-textarea"
                      rows={4}
                    />
                    {this.props.editableView && (
                      <ButtonGroup
                        className="annotation-footer-buttongroup"
                        size="small"
                      >
                        <Button
                          type="default"
                          icon="close"
                          onClick={() => {
                            document.getElementById(
                              "annotationTextarea." + annotations[i].id
                            ).value = "";
                            document.getElementById(
                              "annotationInput." + annotations[i].id
                            ).style.display = "none";
                          }}
                        />
                        <Button
                          type="default"
                          icon="check"
                          onClick={() => this.submitReply(annotations[i].id)}
                        />
                      </ButtonGroup>
                    )}
                  </div>
                </footer>
              </section>
            );
          }
        }
      }
    console.log("fired?", annotationWidgets);

    this.setState({ annotationWidgets: annotationWidgets });
  };

  submitReply = annotationId => {
    const replyValue = document.getElementById(
      "annotationTextarea." + annotationId
    ).value;
    if (replyValue.length > 0) {
      console.log("Submitting reply");
      const replies = this.state.replies;
      replies.push(
        <div key className="annotation-reply-same-user">
          <div key className="annotation-reply">
            <div className="annotation-reply-info">{this.state.replyInfo}</div>
            <div className="annotation-reply-text">{replyValue}</div>
          </div>
        </div>
      );
      this.setState({
        replyValue: replyValue,
        replies: replies
      });
      //document.getElementById('replyBox.' + annotationId).classList.add('text-right');
      document.getElementById("replyBox." + annotationId).innerHTML +=
        "<div class='annotation-reply-same-user'><div  class='annotation-reply'> " +
        "   <div class='annotation-reply-info'>" +
        this.state.replyInfo +
        "</div>" +
        "   <div class='annotation-reply-text'>" +
        replyValue +
        "</div>" +
        " </div></div>";
      document.getElementById("annotationTextarea." + annotationId).value = "";
      fetch(
        urlPath +
        "/api/annotationcomment?annotation=" +
        annotationId +
        "&text=" +
        replyValue,
        { method: "POST", credentials: "include", headers: getAuthHeader() }
      )
        .then(response => console.log("Submitted reply", response.text()))
        .catch(e => console.error("Cannot submit reply", e));
    } else {
      console.log("Empty reply");
    }
  };
  toggleReviewed = checked => {
    if (checked)
      document
        .getElementById("annotationWidgetContainer")
        .classList.add("hide-reviewed");
    else
      document
        .getElementById("annotationWidgetContainer")
        .classList.remove("hide-reviewed");
  };

  toggleAllVersions = () => {
    const { showAllVersions } = this.state;
    console.log("toggle!", showAllVersions);

    this.setState({ showAllVersions: !showAllVersions });
    this.triggerDraw();
  };

  checkPermissions() {
    checkPermission(
      "com.ix.adp.model.Annotation.show,com.ix.adp.model.Annotation.reply,com.ix.adp.model.Annotation.mark",
      val => {
        console.log("AnnotationWidget checkPermissions: ", val);
        if (val != null) {
          if (!val["com.ix.adp.model.Annotation.show"]) {
            let elems = document.getElementsByClassName("ann-btn-open");
            for (let i = 0; i < elems.length; i++)
              elems[i].setAttribute("style", "display: none");
          }
          if (!val["com.ix.adp.model.Annotation.reply"]) {
            let elems = document.getElementsByClassName("ann-btn-reply");
            for (let i = 0; i < elems.length; i++)
              elems[i].setAttribute("style", "display: none");
          }
          if (!val["com.ix.adp.model.Annotation.mark"]) {
            document.getElementById("toggleReviewed").style.display = "none";
            document.getElementById("toggleReviewedText").style.display =
              "none";
            let elems = document.getElementsByClassName("ann-btn-review");
            for (let i = 0; i < elems.length; i++)
              elems[i].setAttribute("style", "display: none");
          }
        }
      }
    );
  }

  componentWillReceiveProps() {
    const replies = this.state.replies;
    const comp = this;
    setTimeout(function () {
      comp.setState({
        replies: replies,
        replyInfo: comp.props.currentUser,
        preview: comp.props.preview,
        specId: comp.props.specId,
        admaterial: comp.props.admaterial,
        annotations: comp.props.annotations
      });
      if (document.getElementById("annotationWidgetContainer"))
        document.getElementById("annotationWidgetContainer").innerHTML = "";
      comp.addWidget(comp.props.admaterial, comp.props.annotations);
    }, 100);
  }

  render() {
    return (
      <Row>
        <Col span={24}>
          <Row>
            <Col span={12}>
              <Switch
                size="small"
                id="toggleReviewed"
                onChange={this.toggleReviewed}
              />{" "}
              <span
                data-translationkey="toggleReviewed"
                id="toggleReviewedText"
              >
                {this.props.translations.toggleReviewed}
              </span>
            </Col>
            <Col span={12}>
              <Switch
                size="small"
                id="toggleAllVersions"
                onChange={this.toggleAllVersions}
              />{" "}
              <span
                data-translationkey="toggleAllVersions"
                id="toggleAllVersionsText"
              >
                Toggle All Versions
              </span>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <div id="annotationWidgetContainer">
                {this.state.annotationWidgets}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }

  triggerDraw = () => {
    const replies = this.state.replies;
    const comp = this;

    console.log(
      comp.props,
      comp.props.admaterial,
      comp.props.annotations,
      this.props.annotations
    );

    setTimeout(function () {
      comp.setState({
        replies: replies,
        replyInfo: comp.props.currentUser,
        preview: comp.props.preview,
        specId: comp.props.specId,
        currentUserId: comp.props.currentUserId,
        admaterial: comp.props.admaterial,
        annotations: comp.props.annotations
      });
      document.getElementById("annotationWidgetContainer").innerHTML = "";
      comp.addWidget(comp.props.admaterial, comp.props.annotations);
      comp.checkPermissions();
      comp.props.setExpandablePanels();
    }, 100);
  };

  componentDidMount() {
    this.triggerDraw();
  }
}

export default AnnotationWidget;



// WEBPACK FOOTER //
// ./src/components/AnnotationWidget.js